

import Head from 'next/head'
import styled from 'styled-components'

import StateContext, { SectorDiversification } from 'components/StateProvider'
import { useContext } from 'react'

const About = ({  }) => {
  const state = useContext(StateContext)

  return (
    <S_About>
      <Head>
        <title>About - SIMM</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <S_Container>

        <S_ImageContainer>
          <S_Image src='https://i.ibb.co/QKsbn8h/simm-logo.png' />
        </S_ImageContainer>

        <S_Header>Mission</S_Header>
        <S_P>
          We seek to improve our students’ investment skills through hands-on portfolio management, educational guest speakers, 
          in-depth market analysis, and networking trips to cities such as New York City and Chicago.
        </S_P>

        <S_Image src='https://i.ibb.co/dfVSycL/cropped.jpg'/>


        <S_Header>History</S_Header>
        <S_P>
          Students in Money Management (SIMM) was founded in 2004 by Bonaventure graduate of 1985, Christopher Kinslow. 
          His goal for starting the club was to provide students with hands-on experience in actively managing an investment portfolio. 
          Today, SIMM has over 20 active members and manages a portfolio of { state.sectorDiversification?.['Total:']?.['Sector $']}. SIMM donates one-third of its realized gains to charitable, 
          non-profit organizations and retains one-third in the Equity Fund, with the remaining one-third of gains given back to the endowment for 
          recognition of their current part of the portfolio.
        </S_P>

        <S_Image src='https://i.ibb.co/jHpmQTR/the-swan-business-center.jpg'/>

        <S_Header>Contact</S_Header>

        <S_Subheader>Address</S_Subheader>
        <S_P>
          Room 101<br></br>
          William E. and Ann L. Swan Business Building<br></br>
          St. Bonaventure, NY 14778<br></br>
        </S_P>

        <S_Subheader>Email</S_Subheader>
        <S_P>
          <S_A href='mailto:simmdashboard@gmail.com'>simmdashboard@gmail.com</S_A>
        </S_P>

        <S_Header>Credits</S_Header>

        <S_Subheader>Project Lead</S_Subheader>
        <S_P>
          <S_A href='mailto:mleamon2010@gmail.com'>Matt Leamon</S_A>
        </S_P>

        <S_Subheader>Web Development and Design</S_Subheader>
        <S_P>
          <S_A href='mailto:leamon@outlook.com'>Tom Leamon</S_A>
        </S_P>

        <S_P>
          © Copyright { new Date().getFullYear() }
        </S_P>

      </S_Container>
    </S_About>
  )
}

export default About

const S_About = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  color: var(--Font_Color);

`

const S_Container = styled.div`
  width: 100%;
  padding: 1em 2em;
  max-width: 700px;
  line-height: 1.6em;
`

const S_ImageContainer = styled.div`
  width: 100%;
  background: white;
  margin-bottom: 1.5rem;
`

const S_Image = styled.img`
  width: 100%;
  max-width: 800px;
  height: auto;
`

const S_Header = styled.div`
  font-size: var(--Font_Size_Header);
  margin: 1rem 0;
  font-weight: 600;
`

const S_P = styled.div`
  margin-bottom: 2rem;
`

const S_Subheader = styled.div`
  font-size: var(--Font_Size_Title);
  font-weight: 600;
  margin-bottom: .5rem;
`

const S_A = styled.a`

`